import '@fontsource-variable/bricolage-grotesque'
import '@fontsource-variable/onest'
import '@fontsource-variable/public-sans'
import './index.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/app.tsx'

const container = document.getElementById('root')
if (!container) throw new Error('Не найден контейнер #root')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
